import { alpha, SxProps, Theme } from '@mui/material';

export const NODE_MAX_WIDTH = 380;

export const headerContainerStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const containerStyles = (selected?: boolean): SxProps<Theme> => ({
  minWidth: 300,
  maxWidth: NODE_MAX_WIDTH,
  boxSizing: 'border-box',
  maxHeight: 110,
  borderRadius: '16px',
  position: 'relative',
  transition: 'all 0.2s ease-in-out',
  padding: (theme) => theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: (theme) => theme.spacing(1),
  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.05)',
  border: (theme) => `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: (theme) => `${theme.palette.background.paper}`,

  ...(selected && {
    border: (theme) => `1px solid ${theme.palette.primary.main}`,
    backgroundColor: (theme) => `${alpha(theme.palette.primary.main, 0.08)}`,

    '&:hover': {
      borderColor: (theme) => theme.palette.grey[400],
      backgroundColor: (theme) => `${alpha(theme.palette.grey[500], 0.04)}`,
    },
  }),

  '&::before': {
    backgroundColor: (theme) => theme.palette.paper.background,
    content: '""',
    position: 'absolute',
    borderRadius: 'inherit',
    inset: 0,
    zIndex: -1,
  },
});

export const teamIndicatorStyles: SxProps<Theme> = {
  width: 8,
  height: 8,
  marginTop: 0.5,
  borderRadius: '50%',
};

export const dialOptionWrapperStyles: SxProps<Theme> = {
  width: 28,
  height: 28,
  borderRadius: '50%',
  backgroundColor: (theme) => theme.palette.primary.main,
  color: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const titleStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.text.primary,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: 500,
};

export const selectedTitleStyles: SxProps<Theme> = {
  ...titleStyles,
  color: (theme) => theme.palette.primary.main,
};

export const descriptionStyles: SxProps<Theme> = {
  color: (theme) => theme.palette.text.secondary,
  height: '45px',
  overflow: 'hidden',
  flex: 1,
  fontSize: '0.875rem',
  lineHeight: 1.4,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
};
